import * as moment from 'moment';

import * as SubscriptionActions from '../actions/subscription';
import { dateFrom$ } from '../selectors/subscription';

import * as Utils from '../utils/validateDateRange';

import ReduxAction from '../../../interfaces/ReduxAction';

export const changeSubDateFrom = (): ReduxAction => {
  return (dispatch): void => {

    const error = Utils.validateDateFrom();
    dispatch(SubscriptionActions.subDateError(error));

    setTimeout(() => {
      dispatch(SubscriptionActions.subDateError(null));
    }, 2000);
  };
};

export const changeSubDateTo = (dateTo: Date): ReduxAction => {
  return (dispatch, getState): void => {

    const error = Utils.validateDateTo(dateFrom$(getState()), dateTo);
    dispatch(SubscriptionActions.subDateError(error));

    if (error) {
      return;
    }

    if (dateTo) {

      const subDateTo = `${moment(dateTo).format().slice(0, 11)}00:00:00Z` as unknown as Date;

      dispatch(
        SubscriptionActions.subChangeDateTo(
          subDateTo
        )
      );
    }
  };
};
